export default __webpack_public_path__ + "static/media/flag-es-UY.61f0d55d.png";